import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceAnalysisQueryTemplateType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { useExperienceAnalysis } from "../../../../../api/ai/experience-analysis";
import { TestPilotButton } from "../../../../../components/Buttons/TestPilotButton";
import {
  dispatchExperienceAnalysis,
  experienceAnalysis,
} from "../../../../../store/slices/ai";
import { selectedExperience } from "../../../../../store/slices/experiences";
import {
  mpClickAiExperienceAnalysisCustomButton,
  mpClickAiExperienceAnalysisSummaryButton,
} from "../../../../../utils/mixpanel";
import { Template } from "../Template";

export const GetStartedStep = () => {
  const experience = useSelector(selectedExperience);
  const dispatch = useDispatch();
  const getExperienceAnalysis = useExperienceAnalysis();
  const analysis = useSelector(experienceAnalysis);

  const onClick = (queryTemplate: ExperienceAnalysisQueryTemplateType) => {
    dispatch(
      dispatchExperienceAnalysis({
        type: "setQueryState",
        value: {
          queryTemplate,
        },
      })
    );

    if (!experience.id) {
      return;
    }

    if (queryTemplate === "summary") {
      getExperienceAnalysis.mutate({
        body: {
          experienceId: experience.id,
          assistantId: analysis.assistantId,
          queryTemplate: "summary",
          threadId: "new",
        },
        pathParams: undefined,
        queryParams: undefined,
      });
    }
  };

  return (
    <Template
      leftNode={
        <Grid
          container
          item
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          sx={{ height: "100%" }}
        >
          <Grid item>
            <IgTypography sx={{ fontWeight: 600, fontSize: "18px" }}>
              How can Abie help?
            </IgTypography>
          </Grid>
        </Grid>
      }
      rightNode={
        <Grid
          container
          item
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          sx={{ height: "100%" }}
        >
          <Grid item>
            <IgButton
              igVariant={"testPilotBlueText"}
              onClick={() => {
                dispatch(
                  dispatchExperienceAnalysis({
                    type: "setViewPreviousThreads",
                    value: true,
                  })
                );
              }}
            >
              Previous Threads
            </IgButton>
          </Grid>
          <Grid item>
            <TestPilotButton
              onClick={() => {
                onClick("summary");
                mpClickAiExperienceAnalysisSummaryButton();
              }}
              dark={true}
              text={"I want a summary"}
              hasAccess={true}
            />
          </Grid>
          <Grid item>
            <TestPilotButton
              onClick={() => {
                onClick("custom");
                mpClickAiExperienceAnalysisCustomButton();
              }}
              dark={true}
              text={"I have my own question"}
              hasAccess={true}
            />
          </Grid>
        </Grid>
      }
    />
  );
};
